import MeniBurgerItem from "./MeniBurgerItem";
import MeniSizeItem from "./MeniSizeItem";

import { useRef, useState } from "react";
import { useI18n } from "../../i18n/I18nContext";

function Meni() {
  const { t, translations } = useI18n();
  const burgerTypeList = translations.burgers;
  const pomfritList = translations.menu.fries;
  const soseviList = translations.menu.sauces;
  const picaList = translations.menu.drinks;
  //prilozi tabularni meni
  const sideDishTabs = translations.menu.tabs;

  const [selectedTab, setSelectedTab] = useState(0);
  const [previousTab, setPreviousTab] = useState(0);
  const tabStyle = {
    transform: `translate(${selectedTab * 100}%, 0)`,
  };

  //odredjujemo sta je sa leve strane,a sta sa desne
  let leftArray = pomfritList;
  let rightArray = picaList;
  let currentArray = soseviList;
  let rightPomocniArray = null;
  let direction = selectedTab < previousTab ? "left" : "right";
  if (selectedTab == previousTab) direction = "stay";
  // console.log(direction)

  const listTabs = [pomfritList, soseviList, picaList];
  //pomeri desno
  const goRight = {
    transform: "translateX(100%)",
  };
  const goCenter = {
    transform: "translateX(0%)",
  };
  const goLeft = {
    transform: "translateX(-100%)",
  };

  //koji je burger selektovan
  const [selectedBurgerId, setSelectedBurgerId] = useState(1);

  const selectedBurger =
    burgerTypeList.find((burger) => burger.id === selectedBurgerId) ||
    burgerTypeList[0];
  const selectBurger = (id) => {
    setSelectedBurgerId(id);
  };

  const sizesRef = useRef(null);
  const scrollToSizes = () => {
    if (sizesRef != null) window.scrollTo(0, sizesRef.current.offsetTop - 200);
  };
  return (
    <>
      <section className="meni-section" id="meni">
        <h1 className="meni-heading">{t("menu.heading")}</h1>

        <h2 className="description-meni">{t("menu.description")}</h2>
        <div className="meni-items-container">
          <div className="burger-types-container">
            <h2 className="meni-header">{t("menu.chooseBurger")}</h2>
            {burgerTypeList.map((element, index) => {
              return (
                <MeniBurgerItem
                  key={index}
                  id={element.id}
                  name={element.name}
                  ingredients={element.ingredients}
                  selectBurger={selectBurger}
                  selected={selectedBurgerId == element.id}
                  priceRange={element.priceRange}
                  scrollToSizes={scrollToSizes}
                ></MeniBurgerItem>
              );
            })}
          </div>
          <div className="sizes-container" ref={sizesRef}>
            <h2 className="meni-header">{`2. ${selectedBurger?.name} - ${t(
              "menu.sizesSuffix",
            )}`}</h2>

            {selectedBurger?.sizes?.map((element, index) => {
              return (
                <MeniSizeItem
                  key={index}
                  name={element.name}
                  ingredients={element.ingredients}
                  price={element.price}
                ></MeniSizeItem>
              );
            })}
          </div>
        </div>
        <div className="side-dish-container">
          <h2 className="meni-header">{t("menu.sideDishesHeading")}</h2>

          <div className="types-of-side-dish">
            <ul>
              {sideDishTabs.map((element, index) => {
                return (
                  <li
                    key={index}
                    onClick={() => {
                      //ako je tab selektovan
                      if (index == selectedTab) return;

                      setPreviousTab(selectedTab);
                      setSelectedTab(index);
                    }}
                    className={`${selectedTab == index ? "selected" : ""}`}
                  >
                    {element}
                  </li>
                );
              })}
              <span className={`selected-square`} style={tabStyle}></span>
            </ul>
          </div>
          {/* LEVO */}
          <div
            className={`side-dish-items-container ${
              selectedTab == 1 ? "center" : selectedTab == 2 ? "right" : "left"
            }`}
          >
            <div className={`side-dish-single-type-container left`}>
              {leftArray?.map((element, index) => {
                return (
                  <MeniSizeItem
                    key={index}
                    name={element.name}
                    price={element.price}
                  ></MeniSizeItem>
                );
              })}
            </div>
            {/* Centar */}
            <div className={`side-dish-single-type-container center`}>
              {currentArray?.map((element, index) => {
                return (
                  <MeniSizeItem
                    key={index}
                    name={element.name}
                    price={element.price}
                  ></MeniSizeItem>
                );
              })}
            </div>
            {/* DESNO */}
            <div className={`side-dish-single-type-container right`}>
              {rightArray?.map((element, index) => {
                return (
                  <MeniSizeItem
                    key={index}
                    name={element.name}
                    price={element.price}
                  ></MeniSizeItem>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Meni;
